<template>
  <div class="form-group">
    <label :for="compId" v-bind:class="{ 'visuallyhidden': labelHidden }">{{ $t('common.resetShort') }}</label>
    <button :id="compId" type="button" @click="$emit('clicked')" class="btn btn-brand1 w-100 text-center">
      {{ $t('common.resetShort') }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import _uniqueId from 'lodash.uniqueid'

export default defineComponent({
  name: 'ButtonReset',
  props: {
    iconOnly: { type: Boolean, default: false },
    labelHidden: { type: Boolean, default: false },
  },
  data() {
    return {
      compId: _uniqueId('control-search-')
    }
  }
});
</script>
